import { Button, Group, Switch, TextInput, Modal, Text, Center, Title } from '@mantine/core';
import { IconGridDots, IconSearch } from '@tabler/icons-react';
import React from 'react';
import DataTable from 'react-data-table-component';
import ActionCell from './components/ActionCell';
import useGetAgency from './useGetAgency';
import { useNavigate } from "react-router-dom";
import LoadingErrorContainer from '../../components/placeholders/LoadingErrorContainer';
import AgencyRow from './components/AgencyRow';

const Remote = () => {
    const navigate = useNavigate();
    const { agencyQuery: {
        data, isPending, isError, isRefetching },
        totalRows,
        handleChangePerPage,
        handlePageChange,
        search,
        setSearch
    } = useGetAgency()

    console.log({ data });
    const columns = [
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
            cell: row => <AgencyRow row={row} />,
            width: "200px",
        },
        // {
        //     name: 'Code',
        //     selector: row => row.code ?? 'N/A',
        //     sortable: true,

        // },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,

        },

        {
            name: 'Tiktok Username',
            selector: row => row.tiktok_username,
            sortable: true,

        },

        // {
        //     name: 'Contact Number',
        //     selector: row => '+' + row.country_code + ' ' + row.phone,
        //     sortable: true,

        // },

        // {
        //     name: 'Premium',
        //     selector: row => row?.is_premium ? 'Yes' : 'No',
        //     sortable: true,

        // },
        {
            name: 'Can see abnormal use of code',
            selector: row => row?.can_see_abnormal_use_of_code ? 'Yes' : 'No',
            sortable: true,
            width: "150px",
        },

        {
            name: 'Can remove abnormal use of code',
            selector: row => row?.can_remove_abnormal_use_of_code ? 'Yes' : 'No',
            sortable: true,
            width: "150px",
        },

        {
            name: 'Action',
            cell: row => <ActionCell row={row} />,

            width: "300px",
        },
    ];

    const handleClick = () => {
        navigate('/agencies/create'); // Adjust the path according to your routing setup
    };

    return (
        <LoadingErrorContainer
            isError={isError}
            isLoading={isPending}
            isRefetching={isRefetching}
        >
            <Group justify='space-between'>
                <Title order={3}>Agencies</Title>
                <Group >
                    <TextInput type='search' defaultValue={search} onChange={(event) => setSearch(event?.target?.value)} placeholder='Search' leftSection={<IconSearch size={18} />} style={{ alignSelf: "flex-end" }} />
                    <Button
                        variant="gradient"
                        gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }}
                        onClick={handleClick}
                        leftSection={<IconGridDots style={{ width: '1rem', height: '1rem', alignSelf: "flex-end" }} />}

                    >Create new Agency </Button>
                </Group>
            </Group>
            <DataTable
                columns={columns}
                data={data?.data ?? []}
                progressPending={isPending}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handleChangePerPage}
                onChangePage={handlePageChange}



            // selectableRows

            />

        </LoadingErrorContainer>


    );

}

export default Remote;
